const initialState = {
  isDisplayed: false,
};

const displayHonorairesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "DISPLAY_HONORAIRES":
      return {
        ...state,
        isDisplayed: !state.isDisplayed,
      };
    default:
      return state;
  }
};

export default displayHonorairesReducer;
